module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a29"
    }
  }), _vm._v("Chapter 2: Fire and Brimstone")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("A block from St. Michael’s, Leslie looked up into the late afternoon sky, shielding his eyes as the humming grew to a loud pitch. He knew the damn thing could land anywhere: on the street, down the mews, in one’s own living room for that matter, or in the worst scenario, knock out a block of flats in seconds. The Germans didn’t build their flying bombs to discriminate, only to fall, land, and destroy whatever they came in contact with.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The flying object—it resembled a plane but wasn’t a plane—stopped buzzing and began its descent.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie rushed along the Bayswater Road carrying his purchases, then turned left onto Clarendon Place and went through the gate. He practically flew up the walkway to the rectory. Once inside, he dropped his shopping on the hall table and ran to the parlor window, wondering if he should draw the drapes.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Outside on the street, three small children—two girls and a boy—dawdled along, laughing and bouncing a ball as they went, taking their damned time.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He yelled at them to get home, take shelter, but they couldn’t hear him with the window closed. He rushed back to the front door just as the stained glass panel of the Sacred Heart blew inward, shattering into a kaleidoscope of colored fragments that dug into his arms and legs and cut deep gashes in his face and neck.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Dust and debris drifted down from the ceiling, polluting the air.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Unsteady but still vertical, he pulled out a handkerchief and held it up to his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The room shook again and the ground rolled and shifted under his feet. He fell backward, banging his head on something round-edged, hard.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Robert switched on the overhead light. “Les. Les.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie turned his head on the sweat-soaked pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Les,” Robert said again, this time bending down, a hand on Leslie’s shoulder, gently shaking him awake.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie opened his eyes"), _c('span', {
    staticClass: "t6"
  }, [_vm._v(". “")]), _vm._v("Who will protect the children?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Robert helped him into a sitting position. “You’ve been dreaming.” He drew in a breath and let out a heavy sigh. “More to the point, you’ve had another nightmare.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Samson stirred at Leslie’s feet and glanced Robert’s way. Then, presumably annoyed by the bright light and at such a rude awakening, the dog flipped over on his side and snuggled closer to his mate, Delilah.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Mrs. Crowe materialized in her robe and slippers, a glass in her hand. She held it out to her employer.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Robert passed the generous shot of whiskey to his brother. “Here. Sip this "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("slowly")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Mrs. Crowe ran a hand across her mouth, looking concerned. “There’s a bit of a draft here,” she said, and hurried off.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie broke out with a laugh. “I’ll bet she’s considerably "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("warmer")]), _vm._v(" now after helping herself to a stiff belt.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I can tell you’re getting back to normal,” Robert said. “Drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie gulped down the golden liquid. It seared his throat and he almost wretched.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I told you to sip it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Right. Sorry. I just feel…I need to wake up fast.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You’re shaking. Want to talk about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You’ve heard it all before.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Tell me anyway,” Robert said. “Anything to keep me from finishing my Sunday sermon. After all these years, you’d think the writing would be easier.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Given what we’re living through, how could anything be easy?” Leslie took Robert’s hand in his.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Over the past weeks, the Germans had stepped up their aggression, sending powerful flying bombs over the Channel on the hour every hour, each carrying a two thousand pound warhead. There seemed no end in sight.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“It’s always the same,” Leslie began, “I’m in the rectory parlor when the bomb hits.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“The children on the street?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yes. I wish I knew what it all meant.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Maybe,” Robert said, squeezing his brother’s hand in his, “it’s nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I hear an ‘or’ coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“The damn thing might be trying to tell you something.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Freud would have a field day with me,” Leslie said.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“And myself, as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Nonsense. You’re damn near perfect.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Robert laughed and cuffed him on the chin. “I can stay a bit longer, if you like. Just till you fall back asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’m fine.” Leslie rearranged his pillow and slipped down under the covers. “See, all warm and snug. I’ll be all right, so get back to your sermon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Just so you know, I’ll be next door.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“No hellfire and brimstone, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I promise. We’ve more than our share at the moment.” Robert took the empty glass and tousled his brother’s thinning hair the way he used to when they were children at St. Andrew’s. Then he switched off the light.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf13060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006.vue
// module id = 69
// module chunks = 0